import { SiteBrand } from "@/data/brand"
import { Disney } from "@/data/disney"
import { DataTable, type Filter } from "@/modules/DataTable"
import { LayoutMain } from "@/modules/layout/main"
import {
	type TableColumn,
	type TableSort,
	TableSortDirection,
} from "@/modules/Table"

const columns: TableColumn<Disney.Entry>[] = [
	{
		display: (x: Disney.Entry) => {
			return x.Title
		},
		name: "Title",
	},
	{
		display: (row: Disney.Entry) => {
			if (!row.Released) {
				return "TBD"
			}
			let label = row.Released.getFullYear().toString()
			if (row.Released >= new Date()) {
				label = row.Released.toLocaleDateString()
			}

			return <span title={row.Released.toLocaleDateString()}>{label}</span>
		},
		name: "Released",
		sortFunction: (a: Disney.Entry, b: Disney.Entry) => {
			const valueA = a.Released || new Date("4000-01-01")
			const valueB = b.Released || new Date("4000-01-01")

			return valueA > valueB ? 1 : -1
		},
	},
	{
		display: (x: Disney.Entry) => {
			return x.Studio
		},
		name: "Studio",
	},
]

const defaultSort: TableSort = {
	columnIndex: 1,
	direction: TableSortDirection.DESC,
}

const filters: Record<string, Filter<Disney.Entry>> = {
	studio: {
		defaults: Object.values(Disney.Studio),
		filter: (row: Disney.Entry, selectedValues: string[]): boolean => {
			return selectedValues.includes(row.Studio)
		},
		label: "Studios",
		options: Disney.Studio,
	},
}

export const PageDisney = () => {
	return (
		<LayoutMain Brand={SiteBrand}>
			<h1>Disney</h1>
			<DataTable
				columns={columns}
				data={Disney.Entries}
				defaultSort={defaultSort}
				filters={filters}
			/>
		</LayoutMain>
	)
}
